import React, {Component} from 'react'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import SendIcon from '@material-ui/icons/Send';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

import {useStyles} from './style';
import MessageArea from './MessageArea';

import questions from '../questions';

const pd = require("paralleldots");
pd.apiKey = process.env.REACT_APP_PARALLELDOTS_API;

class Chatbox extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            messages: [],
            index: 0
        }

        this.sendMessage = this.sendMessage.bind(this);
    }

    loadvideos = async (q) => {
        const response = await fetch(
            "https://youtube-search.p.rapidapi.com/search?part=snippet&key=AIzaSyAOsteuaW5ifVvA_RkLXh0mYs6GLAD6ykc&q="+q,
            {
                method: "GET",
                headers: {
                    "x-rapidapi-key":
                        "b5c35766a7msh13d3dbb2a6fc7d6p190b8ajsn3e64119260f3",
                    "x-rapidapi-host": "youtube-search.p.rapidapi.com",
                },
            }
        );
        console.log(response);
        const data = await response.json();
        return JSON.stringify(data);
    };

    loadarticles = async () => {
        const response = await fetch(
            "https://contextualwebsearch-websearch-v1.p.rapidapi.com/api/Search/WebSearchAPI?q=mental%20health&pageNumber=1&pageSize=10&autoCorrect=true",
            {
                method: "GET",
                headers: {
                    "x-rapidapi-key":
                        "b5c35766a7msh13d3dbb2a6fc7d6p190b8ajsn3e64119260f3",
                    "x-rapidapi-host":
                        "contextualwebsearch-websearch-v1.p.rapidapi.com",
                },
            }
        );
        console.log(response);
        const data = await response.json();
        return JSON.stringify(data);
    };

    sendMessage() {
        let messageBox = document.getElementById("text-box");
        let messageVal = messageBox.value;

        if(messageVal) {
            let newMessages = [...this.state.messages, {type:'You', message:messageVal}];
            this.setState({
                messages: newMessages
            })
            messageBox.value = "";

            pd.emotion(messageVal).then((res) => {
                let question;
                let index = Math.floor(Math.random() * 5);
                let emotions = JSON.parse(res).emotion;
                console.log(emotions);
                let maxEmotion = JSON.parse(this.getMaxEmotion(emotions));

                if(this.state.index < 2) {
                    question = questions.Intro[this.state.index];
                }
                else if(maxEmotion.score > 0.5) {
                    let videos = this.loadvideos(maxEmotion.emotion);
                    console.log(this.loadvideos(maxEmotion.emotion));
                    console.log(this.loadarticles(maxEmotion.emotion));
                    if(videos.status == 200) {
                        question = videos.data;
                    }
                    else {
                        question = "⚠️ Error loading resources related to " + maxEmotion.emotion;
                    }
                }
                else {
                    question = questions[maxEmotion.emotion][index];
                }
                console.log(questions[maxEmotion.emotion]);
                this.setState({
                    index: ++this.state.index
                })
                console.log(question);
                let botMsg = question;

                newMessages = [...newMessages, {type:'Bot', message:botMsg}];
                this.setState({
                    messages: newMessages
                })
            }).catch((e) => {
                console.log(e);
            });
        }
    }

    getMaxEmotion(emotions) {
        let maxEmotion = { emotion:'', score:0 };
        for(let e in emotions) {
            if(emotions[e] > maxEmotion.score) {
                maxEmotion.score = emotions[e];
                maxEmotion.emotion = e;
            }
        }
        console.log(maxEmotion);
        return JSON.stringify(maxEmotion);
    }

    render(){
        const {classes}=this.props;
        return (
            <div className={classes.chatBoxContainer}>
                <Grid container justify="center">
                    <Grid item xs={12} sm={9} md={6} lg={6}>
                        <Paper>
                            <div className={classes.messageArea} style={{width:"100%"}}>
                                <MessageArea messages={this.state.messages}/>
                            </div>
                            <div style={{display:'flex', padding:10}}>
                                <TextField 
                                    id="text-box" 
                                    placeholder="Enter Text" 
                                    margin="normal"
                                    className ={classes.textBox}
                                    variant="outlined"
                                    fullWidth={true}
                                />
                                <IconButton onClick={this.sendMessage} aria-label='add' color='primary' type='submit'>
                                    <SendIcon />
                                </IconButton>
                            </div>
                        </Paper>  
                    </Grid>  
                </Grid>
            </div>
        )
    }
}

export default withStyles(useStyles)(Chatbox)
